<script>
import { playAction } from '../common/play_common';
import { game } from '../store/store';

export let boardField, ind;

async function fieldSelect() {
    await playAction(ind);
}

function playerColor(uId) {
    const colorVal = $game.playerColorGet(uId);
    return colorVal;    
}

</script>

<div class="board-field">
    {#if boardField.active}
        <button class="field-button" on:click={fieldSelect}>{boardField.num}</button>
        {#each boardField.players as playerId}
            <span class="player-select" style="border-color: {playerColor(playerId)};"></span>
        {/each}
    {/if}
</div>

<style>
.board-field {
    display: flex;
    flex-direction: column;    
    font-size: 1em;
    min-height: 15%;
    text-align: center;
}

@media only screen and (min-width: 1000px) {
    .board-field {
        flex-direction: row;    
        min-width: 10%;
        min-height: auto;
        text-align: center;
    }
}

.field-button {
    background-color: transparent;
    border: 0px;
}

.field-button:hover {
    background-color: azure;
}

.player-select {
    border-style: solid;
    border-width: 0.3em; 
    margin-top: 0.2em;
}

@media only screen and (min-width: 1000px) {
    .player-select {
        border-top: 0em; 
        margin-top: 0em;
        border-left: 0.5em solid; 
        margin-left: 0.2em;
    }

}

</style>